<template>
  <a-config-provider :locale="zhCN">
<!--    <router-view></router-view>-->
    <div class="layout">
      <headerbox/>
      <homepagebox/>
      <div style="clear:both"><footbox/></div>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('en')
export default {
  data () {
    return {
      zhCN
    }
  }
}
</script>

<script setup>
import { ref } from 'vue';
import headerbox from './views/header.vue'
import homepagebox from './views/indexCon.vue'
import footbox from './views/footer.vue'
</script>

<style scoped>
</style>